import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";
import { DropDownComponent } from "../../Components/DropDownComponent";
import { app } from "../../Frame/App";
import { MsoTable } from "./MsoTable";
import { ITableColumn } from "./ITableColumn";

export class ColumnDropdown extends ColumnBase {

    public constructor(table: MsoTable, def: ITableColumn, rootId: string) {
        super(table, def, rootId)
    }

    getCellClass(): string {
        return super.getCellClass() + " mt-dropdown";
    }

    public getContent(row: any): HTMLElement {
        let dropdown = new DropDownComponent({
            id: app.createGuid(),
            displayProperty: "name",
            valueProperty: "id",
            items: this.getItems(row),
            onChange: this.onChange
        });
        const element = dropdown.render();
        dropdown.setValue(row[this.field]);
        dropdown.props.onChange = this.onChange;
        element.setAttribute("data-id", row[this.table.props.idField]);
        return element;
    }

    public recreate(cell: HTMLElement, model: any) {
        cell.innerHTML = "";
        let newContent = this.getContent(model);
        if (newContent) {
            cell.appendChild(newContent);
        }
    }

    onChange = (control: DropDownComponent) => {
        if (this.table.props.onModelChanged) {
            let id = control.element.getAttribute("data-id");
            let model = this.table.getRowModel(id);
            if (model) {
                if (typeof model[this.field] === "number") {
                    model[this.field] = parseInt(control.getValue());
                }
                else {
                    model[this.field] = control.getValue();
                }
                this.table.props.onModelChanged(this.field, model);
            }
        }
    }

    getItems(model: any): any[] {
        if (this.table.props.onGetDataSource) {
            if (this.def.sourceName && this.def.sourceName.length > 0) {
                return this.table.props.onGetDataSource(this.field, this.def.sourceName);
            }
            else if (this.def.sourceField && this.def.sourceField.length > 0) {
                return this.table.props.onGetDataSource(this.field, model[this.def.sourceField]);
            }
        }
        return null;
    }
}